import dayjs from 'dayjs';
import i18n from '@/localisation/i18n';

export type AggregatedData<T> = {
  date: string;
  list: T[];
};

export function aggregateDataByDate<T extends { creationDate: string }>(
  data: T[]
): AggregatedData<T>[] {
  const aggregatedMap = new Map<string, T[]>();
  const today = dayjs();
  const yesterday = dayjs().subtract(1, 'day');

  data.forEach(entry => {
    const entryDate = dayjs(entry.creationDate);
    let formattedDate: string;

    if (entryDate.isSame(today, 'day')) {
      formattedDate = i18n.t('today');
    } else if (entryDate.isSame(yesterday, 'day')) {
      formattedDate = i18n.t('yesterday');
    } else {
      formattedDate =
        entryDate.year() === today.year()
          ? entryDate.format('D MMMM')
          : entryDate.format('D MMMM YYYY');
    }

    if (!aggregatedMap.has(formattedDate)) {
      aggregatedMap.set(formattedDate, []);
    }
    aggregatedMap.get(formattedDate)!.push(entry);
  });

  // Преобразуем Map в массив объектов нужной структуры
  return Array.from(aggregatedMap, ([date, list]) => ({ date, list }));
}
